import { defineMessages } from "react-intl";

export default defineMessages({
  Title: {
    id: "Resume.Title",
    defaultMessage: "Reprendre là où vous en étiez ?",
  },
});
